module.exports = __webpack_public_path__ + "static/media/meter2.7fb1b05f.svg";